"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var errorUtils_1 = require("spry-react/utils/errorUtils");
var labeled_1 = require("spry-react/Label/labeled");
var lockToggle_1 = require("spry-react/Label/lockToggle");
var reactEventHandling_1 = require("spry-react/Text/reactEventHandling");
require("../Warnings/warning.less");
var textField_1 = require("./textField");
var TextAreaField = /** @class */ (function (_super) {
    __extends(TextAreaField, _super);
    function TextAreaField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextAreaField.prototype.render = function () {
        var _a = this.props, required = _a.required, errorMessage = _a.errorMessage, className = _a.className, value = _a.value, title = _a.title, domProps = __rest(_a, ["required", "errorMessage", "className", "value", "title"]);
        var classes = classNames(className, {
            'required': required
        });
        return React.createElement("textarea", __assign({}, domProps, errorUtils_1.toErrorProps(classes, title, errorMessage), { value: textField_1.CoalesceToEmptyString(value), onChange: reactEventHandling_1.ToReactEventHandler(this.props.onChange), "aria-required": required }));
    };
    return TextAreaField;
}(React.Component));
exports.TextAreaField = TextAreaField;
exports.LabeledTextAreaField = labeled_1.labeled(TextAreaField);
exports.LockToggleTextAreaField = lockToggle_1.lockToggle(TextAreaField);
